import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import t from '@jetshop/intl';
import { PaginationBehaviour } from '@jetshop/ui/Pagination';
import { PaginationWrapper } from './Pagination/PaginationWrapper';
import React from 'react';
import { styled } from 'linaria/react';
import CategoryHeader from '../CategoryPage/CategoryHeader';
import CategoryHeaderLoadingState from './CategoryHeaderLoadingState';
import Filters from './Filters';
import ProductGrid from './ProductGrid';
import { PagePadding } from '../Layout/MaxWidth';
import { ContentPadding } from '../Layout/Content/Content';

const Container = styled('div')`
  ${ContentPadding}
`;

const CategoryWrapper = styled('div')``;

const ProductNumberText = styled('p')`
  color: #878787;
  letter-spacing: 0.5px;
  margin: 0.5rem 0;
  font-size: 0.9rem;
`;

export const ProductNumber = ({ total }) => {
  return (
    <ProductNumberText>
      {t('{total, plural, =1 {# product} other {# products}}', {
        total,
      })}
    </ProductNumberText>
  );
};

const Category = ({ category, result }) => {
  const standardCategory =
    category?.products?.filters.length > 0 ||
    category?.products?.totalResults > 0;

  if (!category) {
    return (
      <CategoryWrapper>
        <PagePadding>
          <CategoryHeaderLoadingState />
        </PagePadding>
      </CategoryWrapper>
    );
  }

  return (
    <CategoryWrapper>
      <CategoryHeader
        category={category}
        parents={result?.data?.route?.parents}
        standardCategory={standardCategory}
      />
      <Filters
        filters={category.products?.filters || []}
        sortOrders={category.products?.sortOrders || []}
        result={result}
      />
      <PagePadding>
        <Container>
          {standardCategory && (
            <ProductNumber total={category.products.totalResults} />
          )}
          <ProductGrid
            products={category.products.result}
            listName={category.name}
            categoryPath={category.isDynamic ? null : result?.data?.route}
            loading={result.loading}
            imageSizes={[1 / 2, 1 / 2, 1 / 3, 1 / 4]}
          />

          <PaginationContext.Consumer>
            {(props) => {
              return (
                <PaginationBehaviour
                  {...props}
                  total={category.products.totalResults}
                >
                  {(props) => <PaginationWrapper {...props} />}
                </PaginationBehaviour>
              );
            }}
          </PaginationContext.Consumer>
        </Container>
      </PagePadding>
    </CategoryWrapper>
  );
};

export default Category;
